module.exports = __webpack_public_path__ + "static/media/Carroceria_.fb8c82b2.svg";